import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
    drawer: null,
    jwt: localStorage.getItem("jwt"),
    user: JSON.parse(localStorage.getItem("user")),
    path: [],
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    setJwt: (state, jwt) => {
      state.jwt = jwt;
    },
    setUser: (state, user) => {
      state.user = user;
    },
    setPath: (state, path) => {
      state.path = path;
    },
  },
  getters: {
    path: state => state.path,
    jwt: state => state.jwt,
    user: state => state.user,
  },
  actions: {
    setJwt: (context, jwt) => {
      context.commit("setJwt", jwt);
    },
    setUser: (context, user) => {
      context.commit("setUser", user);
    },
    setPath: (context, path) => {
      context.commit("setPath", path);
    },
  },
});
